export default "__VITE_ASSET__SIbYt_VV__"